import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import image from '../images/pp-vol3.jpg';
import pdf from '../pdfs/flyerbinary.pdf'; 
import { Helmet } from 'react-helmet';

function LeibnizOnBinary() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function scrollToElement(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        <a href="https://global.oup.com/academic/product/leibniz-philosophical-papers-16771686-9780198960034" target="_blank" rel="noopener noreferrer">Order from the publisher (Oxford University Press)</a><br /><br />
        <a href="https://www.amazon.co.uk/Leibniz-Philosophical-1677-1686-IReligion-Theology/dp/0198960034/" target="_blank" rel="noopener noreferrer">Order from Amazon (UK)</a><br /><br />
        <a href="https://www.amazon.com/Leibniz-Philosophical-1677-1686-Religion-Theology/dp/0198960034/" target="_blank" rel="noopener noreferrer">Order from Amazon (US)</a><br /><br />
      </div>
    );
  }

  function endorsements() {
    return (
      <>
      <p>Endorsements:</p>
      
      </>
    );
  }
  
  return (
    <div>
       <Helmet>
            <title>Leibniz: Philosophical Papers 1677-1686: Religion and Theology</title>
            <meta name="description" content="A book authored by Lloyd Strickland on 'Philosophical Papers 1677-1686: Religion and Theology'" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()} <hr className="centered-hr" />
                    {endorsements()}
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: PHILOSOPHICAL PAPERS 1677-1686: RELIGION AND THEOLOGY</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}
                    <p>View endorsements <span style={{color: 'blue'}} onClick={() => scrollToElement('endorsements')}>here</span></p>
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                  <img src={image} alt="Philosophical Papers 1677-1686: Religion and Theology" style={{ float: 'left', marginRight: '20px', height: isMobile ? '220px' : '364px', width: 'auto' }} />
                  <p style={{ margin: '10px 0px 0px 0px', fontSize: '13px' }}>Published 30 April 2026, by Oxford University Press.</p><br />
                  <p>From the back cover blurb:</p>
                  This volume brings together 52 of Leibniz's writings on religion and theology, including the book-length <var>Examination of the Christian Religion</var>, in which he defends the Roman Catholic position on various matters of controversy, despite being a lifelong Lutheran himself. Also included are the complete texts from an unfinished project, <var>Apology for Catholic Truth</var>, in which Leibniz writes in the guise of a Catholic. Other writings reflect several of Leibniz's long-term projects: constructing a philosophical defence of Christianity to show the compatibility of its doctrines with reason; undermining philosophies he believed could lead to atheism, in particular those of Hobbes, Descartes, Spinoza; and developing methods for resolving theological disputes.<br /><br />

This collection traces the evolution of these projects during Leibniz's formative first decade in Hanover (1677-1686), offering the most comprehensive English-language selection of such writings to date. Strickland has returned to Leibniz's original manuscripts to produce accurate, carefully annotated translations that document textual variations, deletions, and marginalia. Of the 52 texts included, 29 appear in English for the first time, one has never been published in any language, and another has only been partially published in its original form.<br /><br />

In addition to the translations, the volume features a substantial introductory essay on Leibniz's life, work, and writings on religion and theology from 1677 to 1686, along with detailed explanatory notes on each text, providing context, background, and the rationale for their dating.<br />
                  <br clear = "all" />
                  <b>TABLE OF CONTENTS</b><br /><br />
                  Abbreviations<br /><br />
                  Introduction<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1. Leibniz's Life 1677-1686<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2. Leibniz's Writings 1677-1686<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3. Overview: Religion and Theology 1677-1686<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4. About the Volumes, Selections of Texts, Apparatus and Typographical Conventions<br /><br />
<b>Religion and Theology</b><br /><br />
<ol>
<li>Consideration of the Strongest Passages Which Are Adduced from Holy Scripture and the Holy Fathers in Favour of Purgatory (January 1677)</li>
<li>Summary Explanation of Revelation (January 1677)</li>
<li>On the Breaking of Ecclesiastical Communion (January-April 1677 (?))</li>
<li>On the Obligation to Believe (January-April 1677 (?))</li>
<li>Civil and Sacred Controversies (January-April 1677 (?))</li>
<li>On General Sacred Controversies (January-April 1677 (?))</li>
<li>Remarks on Steno's Conversion (March 1677)</li>
<li>On Controversies (March 1677)</li>
<li>The Judge of Controversies (first half of 1677 (?))</li>
<li>Various Definitions of the Church (first half of 1677 (?))</li>
<li>What Is It to Be or Not to Be in the Roman Church? (first half of 1677 (?))</li>
<li>On the Worship of the Saints (before 23 July 1677)</li>
<li>Demonstration That the Host Should Not Be Adored (October 1677)</li>
<li>There Is Only One God (1678 (?))</li>
<li>Preface to a Planned Latin Translation of Bossuet's <var>Exposition of the Catholic Faith</var> (1678 - May 1679)</li>
<li>Dialogue between a Theologian and a Misosophist (July 1678 - first half of 1679 (?))</li>
<li>Dialogue between Poliander and Theophile (mid-1679 (?))</li>
<li>Conversation between the Marquis of Pianezza, Minister of State of Savoy, and Father Emery, a Hermit (July-early August 1679 (?))</li>
<li>Dialogue between an Able Politician and an Ecclesiastic of Recognized Piety (July-early August 1679 (?))</li>
<li>Dialogue between Theophile and Polidore (autumn 1679 (?))</li>
<li>On Scripture, the Church, and the Trinity (1680–1684 (?))</li>
<li>On the Triune God (1680-1684 (?))</li>
<li>On the Person of Christ (1680-1684 (?))</li>
<li>The Physical Origin of Circumcision (February/March 1681 - end of 1682 (?))</li>
<li>Opinion on the Nature and Power of the Catholic Church (January-April 1684 (?))</li>
<li>Reflections on the Change of External Profession of Religion and What Should Be Proved by Protestants Who Refuse to Return to the Roman Church, if in Good Conscience They Prefer to Remain in Separation (spring 1684-1685 (?))</li>
<li>On Attending to the Salvation of the Soul (February-October 1685 (?))</li>
<li>On Not Violating the Principle of Contradiction in Divine Matters (February-October 1685 (?))</li>
<li>On the Trinity (February-October 1685 (?))</li>
<li>Account of the Exploits of the Bishop of Tina in Hanover in 1683 and the Ill-Will That Was Unjustly Stirred Up among the Saxons as a Result (end of May 1685)</li>
<li>Protestant Complaints about Roman Catholic Dogmas and Practices (May-June 1685 (?))</li>
<li>The Proper Starting Point of Our Faith (May-June 1685 (?))</li>
<li>On the Unity of the Church (May-June 1685 (?))</li>
<li>Brief Preparatory Remarks in Relation to Apologetic Works (May-June 1685 (?))</li>
<li>Apology for the Catholic Faith Based on Right Reason (May-June 1685 (?))</li>
<li>Rationale of the Catholic Faith against Sects of All Kinds (May-June 1685 (?))</li>
<li>Specimen of Catholic Demonstrations, or, Apology for the Faith Based on Reason (May-June 1685 (?))</li>
<li>Discussion about an Apology for Catholic Truth (May-June 1685 (?))</li>
<li>On Attempting an Apology for Catholic Truth (May-June 1685 (?))</li>
<li>The Authority of the Church (May-June 1685 (?))</li>
<li>On the Catholic Church (May-June 1685 (?))</li>
<li>Thoughts about the Disagreement between Protestants and Eastern Churches (May-June 1685 (?))</li>
<li>The One Catholic Church (May-June 1685 (?))</li>
<li>On the Commandment of Love, Schism, and the Principles of the Church (May-June 1685 (?))</li>
<li>Apology for Catholic Truth (May-June 1685 (?))</li>
<li>On Schism, Catholic Faith, and the Catholic Church (May-June 1685 (?))</li>
<li>Rationale of the Catholic Faith (May-June 1685 (?))</li>
<li>Theses (autumn 1685 - spring 1686 (?))</li>
<li>On God and the Church (autumn 1685 - spring 1686 (?))</li>
<li>Theological Propositions (autumn 1685 - spring 1686 (?))</li>
<li>Examination of the Christian Religion (first quarter of 1686 (?))</li>
<li>On the Religion of Great Men (spring 1686-1687 (?))</li>
</ol>

                  Bibliography<br /><br />
                  Index
                  <br></br><br></br>
                  {isMobile ? (
                    <div id="endorsements">
                      <hr></hr><p style={{paddingTop: '10px'}}>Go back to the top of the page <span style={{color: 'blue'}} onClick={() => scrollToElement('top')}>here</span></p>
                      {endorsements()}
                    </div>
                  ) : (
                    <>
                    </>
                  )}
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default LeibnizOnBinary;
